import Variant from './Variant'

class Output implements Variant {
  public output = true

  toString(): string {
    return 'o'
  }
}

export default Output
